export default __webpack_public_path__ + "static/media/Car_image_1.dd93eb68.svg";